/**
 * @lines98/client/ui/toast — лёгкий toast-уведомления.
 *
 * Mirrors prototype `toast()` (lines 882-883): grabs the #toast element,
 * sets text, flashes for 1.6 s. Reuses the global element from `index.html`
 * — no per-call DOM allocation.
 */

let timer: number | null = null;

export function showToast(message: string, durationMs = 1600): void {
  // Defensive: no-op в non-DOM environments (Node test runner, SSR). Lets
  // callers fire a toast without guarding `typeof document` at every site.
  if (typeof document === 'undefined') return;
  const el = document.getElementById('toast');
  if (!el) return;
  el.textContent = message;
  el.classList.add('show');
  if (timer !== null) {
    window.clearTimeout(timer);
  }
  timer = window.setTimeout(() => {
    el.classList.remove('show');
    timer = null;
  }, durationMs);
}

/**
 * Немедленно скрыть тост и снять отложенное скрытие. Нужно при уходе с экрана, чтобы
 * долгоиграющий тост (напр. 5с «Адрес скопирован…» на «Поддержать») не висел поверх
 * следующего экрана (owner-directive 2026-06-27).
 */
export function hideToast(): void {
  if (typeof document === 'undefined') return;
  if (timer !== null) {
    window.clearTimeout(timer);
    timer = null;
  }
  document.getElementById('toast')?.classList.remove('show');
}
